export default __webpack_public_path__ + "static/media/cronos.84003ca5.svg";